import {RulebookStyle} from '../../../../shared/enums/RulebookEnums'
import {clientIntl} from '../ClientI18n'
import {StorageWrapper} from '../StorageWrapper'
import {UIUrlParameterNames} from '../ui_html/UIUrlController'
import {UIScrollController} from '../ui_scroll_controller/UIScrollController'
import {getHomepageUrl, navigateToPage} from '../ui_utils/ClientUtils'
import {setElementOnClick} from '../ui_utils/DomUtils'
import {UIEntryUrlParameterController} from '../UIEntryUrlParameterController'
import {UIMSceneEnum} from '../../../../shared/enums/UIMSceneEnums'

export class UIRulebookController extends UIScrollController {
    private static rulebookStyle: RulebookStyle | null

    constructor() {
        const urlParams = new URLSearchParams(window.location.search)
        UIRulebookController.rulebookStyle = urlParams.get('style') as RulebookStyle ?? null

        UIRulebookController.setupBackButtonListener()
        UIRulebookController.setupLogoButtonListener()

        const rulebookContentElement = document.getElementById('rulebook-content') as HTMLDivElement
        const rulebookContentContainer = rulebookContentElement.getElementsByClassName('rulebook-content-container')[0] as HTMLDivElement
        const rulebookSideNavigationElement = document.getElementById('rulebook-side-navigation') as HTMLDivElement

        super(rulebookContentContainer, rulebookSideNavigationElement, rulebookContentElement, 'side-navigation-link-current-section')

        rulebookContentElement.addEventListener('scroll', () => this.onContentScroll())
        this.setupLinkListener()
        UIRulebookController.setRulebookLinksStyle()
    }

    private static setupBackButtonListener() {
        const backButton = document.getElementById('rulebook-header-back-button') as HTMLImageElement | undefined
        if(backButton == undefined) return
        setElementOnClick(backButton, () => UIRulebookController.goBack())
    }

    private static setupLogoButtonListener() {
        const logoButton = document.getElementById('rulebook-header-logo-button') as HTMLImageElement | undefined
        if(logoButton == undefined) return
        setElementOnClick(logoButton, () => UIRulebookController.goBack())
    }

    private static goBack() {
        const url = UIRulebookController.getRulebookHomepageUrl()
        StorageWrapper.clearLastScene()
        navigateToPage(url)
    }

    private setupLinkListener() {
        // eslint-disable-next-line no-restricted-syntax
        document.body.addEventListener('click', (e: MouseEvent) => {
            if(e.target == null) return

            const link = e.target as HTMLElement
            const closestNavigationSectionLink = link.closest('a')
            const isSectionLink = closestNavigationSectionLink?.href.includes('#')
            if(!isSectionLink) return
            if(closestNavigationSectionLink !== null) this.onSidebarClick(e)
        })
    }

    private static setRulebookLinksStyle() {
        if(UIRulebookController.rulebookStyle == null) return

        document.querySelectorAll('a').forEach((link: HTMLAnchorElement) => {
            const isInternalLink = link.href.startsWith(location.origin)
            if(!isInternalLink) return

            const isSamePage = link.pathname === location.pathname
            if(isSamePage) return

            const url = new URL(link.href)
            url.searchParams.set('style', UIRulebookController.rulebookStyle as string)
            link.href = url.toString()
        })
    }

    private static getRulebookHomepageUrl() {
        if(UIRulebookController.rulebookStyle != RulebookStyle.Mobile) return getHomepageUrl()

        const lastScene = StorageWrapper.getLastScene()
        if(lastScene == null) return `${clientIntl.getLanguagePathPrefix()}/mobile`

        const mobileSceneParameter = UIRulebookController.getMobileSceneParameter(lastScene)
        return `${clientIntl.getLanguagePathPrefix()}/mobile#${mobileSceneParameter}=${UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE}`
    }

    private static getMobileSceneParameter(scene: UIMSceneEnum): UIUrlParameterNames {
        switch(scene) {
            case UIMSceneEnum.Leaderboard: return UIUrlParameterNames.MobileLeaderboard
            case UIMSceneEnum.Lobby: return UIUrlParameterNames.MobileLobby
            case UIMSceneEnum.Store: return UIUrlParameterNames.MobileStore
            case UIMSceneEnum.More: return UIUrlParameterNames.MobileMore
            default: return UIUrlParameterNames.MobileHomepage
        }
    }
}
